import React, { useState, useEffect } from "react"; // React와 상태 관리를 위한 useState를 불러옵니다.
import { useSearchParams } from "react-router-dom";
import Modal from "react-modal"; // 모달(팝업 창)을 쉽게 구현할 수 있는 라이브러리입니다.
import Blank from "components/common/Blank";
import "slick-carousel/slick/slick.css"; // 이미지 슬라이더 기본 스타일을 적용하기 위한 CSS 파일입니다.
import "slick-carousel/slick/slick-theme.css"; // 이미지 슬라이더의 테마 스타일을 적용하기 위한 CSS 파일입니다.
import "@fortawesome/fontawesome-free/css/all.min.css"; // Font Awesome 아이콘 스타일입니다.
import Footer from "components/Footer";
import useUserStore from "@store/useUserStore";
import { getMainBannerList } from "api/mainTab";
import useUnreadCounts from "hooks/useUnreadCounts";
import PopUpBanner from "components/common/PopUpBanner";
import Seo from "components/common/Seo";

import {
    isBannerHidden,
    cleanupExpiredBanners,
} from "utils/popupBannerStorage";
import HomeHeader from "components/home/HomeHeader";
import HomeContents from "./HomeContents";

Modal.setAppElement("#root");

const DEEPEST_BRAND_NAME = "더 딥스";


// 메인 페이지 컴포넌트입니다.
function MainPage() {
    const homeBrand = useUserStore((state) => state.homeBrand);
    const { notificationCount: unreadCount, messageUnreadCount } = useUnreadCounts();
    const [searchParams, setSearchParams] = useSearchParams();
    const [popupBanner, setPopupBanner] = useState(null); // 팝업 배너

    useEffect(() => {
        if (!homeBrand) return;
        if (searchParams.has("brand")) return;
        if (homeBrand.home_brand_name === DEEPEST_BRAND_NAME) return;
        const next = new URLSearchParams(searchParams);
        next.set("brand", String(homeBrand.home_brand_id));
        setSearchParams(next, { replace: true });
    }, [homeBrand, searchParams, setSearchParams]);


    useEffect(() => {
        getMainBannerList()
            .then((res) => {
                const bannerList = res.results || [];
                const now = new Date().toISOString();

                // 게시 기간 내에 있는 항목만 필터링
                const activeBanners = bannerList.filter((banner) => {
                    const startDate = new Date(banner.start_date).toISOString();
                    const endDate = new Date(banner.end_date).toISOString();
                    return now >= startDate && now <= endDate;
                });

                if (activeBanners.length === 0) {
                    setPopupBanner(null);
                    return;
                }

                // 오래된 항목 정리
                cleanupExpiredBanners();

                // localStorage에서 공지 id별로 24시간 안보기 체크
                const visibleBanners = activeBanners.filter((banner) => {
                    if (!banner.id) return true; // id가 없으면 표시

                    // 24시간 내에 안보기로 설정되지 않은 공지만 표시
                    return !isBannerHidden(banner.id);
                });

                if (visibleBanners.length === 0) {
                    setPopupBanner(null);
                    return;
                }

                // priority가 높을수록 우선순위가 높음
                const sortedBanners = visibleBanners.sort(
                    (a, b) => b.priority - a.priority
                );

                // 우선순위가 가장 높은 항목 1개만 선택
                setPopupBanner(sortedBanners[0]);
            })
            .catch((err) => {
                console.error("팝업 배너 조회 실패:", err);
                setPopupBanner(null);
            });
    }, []);


    return (
        <>
            <Seo />
            <HomeHeader notificationCount={unreadCount} messageNotificationCount={messageUnreadCount} />
            <HomeContents/>
            <Footer />
            <PopUpBanner data={popupBanner} />

        </>
    );
};

export default MainPage;
